var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status-wrapper"},[(_vm.count > 0.6)?_c('PtIcon',{attrs:{"icon":"SolidDataHighCoverage"}}):(_vm.count > 0)?_c('PtIcon',{attrs:{"icon":"SolidDataLowCoverage"}}):_c('span',{staticClass:"empty"},[_vm._v("-")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }